export default "__VITE_ASSET__65a4d132__"